import React from "react";
import { Column, Columns, Table } from "@allxsmith/bestax-bulma";
import {readableDate} from "../../utils";


class PrintOrderForm extends React.Component{

    render (){
        let order = this.props.order;
        let vehicle = this.props.vehicle;
        let today = new Date()
        today = today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate();

        return (
            <div>
                <Columns isMultiline>
                    <Column>
                        <Table isBordered isFullwidth>
                            <tbody>
                                <tr>
                                    <th colSpan={8} className={"table-header-bold border-black fill-grey"}>ORDER FORM</th>
                                </tr>
                                <tr>
                                    <th colSpan={8} className={" table-header-bold border-black fill-grey"}>ORDER INFO</th>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>ORDERED DATE:</th>
                                    <td colSpan={3} className={"wide-column border-black"}>{readableDate(order.ordered_date)}</td>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>ORDER NUMBER:</th>
                                    <td colSpan={3} className={"wide-column border-black"}>{order.order_number}</td>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>DATE/MONTH EXPECTED:</th>
                                    <td colSpan={3} className={"wide-column border-black"}>{order.month_due}</td>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>SUPPLIER</th>
                                    <td colSpan={3} className={"wide-column border-black"}>{order.vehicle_supplier ? order.vehicle_supplier.display_name: ""}</td>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>NEW DEPARTMENT OWNER:</th>
                                    <td colSpan={3} className={"wide-column border-black"}>{order.department ? order.department.name : ""}</td>
                                    <th className={"table-header-bold fill-grey border-black small-text"}></th>
                                    <td colSpan={3} className={"wide-column border-black"}></td>
                                </tr>
                                <tr>
                                    <th colSpan={8} className={"table-header-bold fill-grey border-black"}>INVOICE DETAILS</th>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>PURCHASE PRICE:</th>
                                    <td colSpan={3} className={"wide-column border-black"}>£{order.ordered_purchase_price}</td>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>INVOICE NUMBER:</th>
                                    <td colSpan={3} className={"wide-column border-black"}>{order.purchase_invoice_number}</td>
                                </tr>
                                <tr>
                                    <th colSpan={8} className={"table-header-bold fill-grey border-black"}>VEHICLE DETAILS</th>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>REGISTRATION:</th>
                                    <td colSpan={3} className={"wide-column border-black"}>{vehicle.registration}</td>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>CHASSIS NUMBER:</th>
                                    <td colSpan={3} className={"wide-column border-black"}>{vehicle.vin_number}</td>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>MAKE:</th>
                                    <td colSpan={3} className={"wide-column border-black"}>{vehicle.make ? vehicle.make.name : ""}</td>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>MODEL:</th>
                                    <td colSpan={3} className={"wide-column border-black"}>{vehicle.model ? vehicle.model.name : ""}</td>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>TYPE:</th>
                                    <td colSpan={3} className={"wide-column border-black"}>{vehicle.type ? vehicle.type.name : ""}</td>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>DATE OF FIRST REGISTRATION:</th>
                                    <td colSpan={3} className={"wide-column border-black"}>{readableDate(vehicle.first_registration_date)}</td>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>MILEAGE:</th>
                                    <td colSpan={3} className={"wide-column border-black"}>{vehicle.mileage}</td>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>COMMENTS:</th>
                                    <td colSpan={3} className={"wide-column border-black"}>{order.ordering_comments}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Column>
                </Columns>
            </div>
        );
    }



}
export default PrintOrderForm;